import { Logo } from '@/components/brand/logo'

export function FullPageLoader() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-background" role="status" aria-live="polite">
      <Logo markOnly className="size-9 animate-pulse motion-reduce:animate-none" />
      <span className="sr-only">Loading</span>
    </div>
  )
}
